// Dates and numbers the way TrustClap writes them: "30 Oct 2026", "30 Oct 2026, 14:02".
function parse(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(String(value).length === 10 ? value + 'T00:00:00' : value);
  return isNaN(date.getTime()) ? null : date;
}

export function formatDate(value) {
  const date = parse(value);
  return date ? date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
}

export function formatDateTime(value) {
  const date = parse(value);
  if (!date) return '';
  return formatDate(date) + ', ' + date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}

export function formatRelative(value) {
  const date = parse(value);
  if (!date) return '';
  const minutes = Math.round((Date.now() - date.getTime()) / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return minutes + ' min ago';
  const hours = Math.round(minutes / 60);
  if (hours < 24) return hours + (hours === 1 ? ' hour ago' : ' hours ago');
  const days = Math.round(hours / 24);
  if (days < 7) return days + (days === 1 ? ' day ago' : ' days ago');
  return formatDate(date);
}

export function plural(count, one, many) {
  return count + ' ' + (count === 1 ? one : (many || one + 's'));
}

export function number(value) {
  return Number(value || 0).toLocaleString('en-GB');
}

// "Brindle & Rye's", but "Willow Lane Ceramics'": a name ending in s takes the apostrophe alone.
export function possessive(name) {
  const text = String(name || '');
  return text + (/s$/i.test(text) ? "'" : "'s");
}

// Ends a sentence with a name: "Harbour Loaf Co." already has its full stop.
export function withStop(text) {
  const value = String(text || '');
  return /[.!?]$/.test(value) ? value : value + '.';
}

// "name, company and photo"
export function listText(items) {
  const list = (items || []).filter(Boolean);
  return list.length > 1 ? list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1] : (list[0] || '');
}
